module.exports = __webpack_public_path__ + "media/images/badges/akt/AKT_BadassLoyaltyProgram_InvertedBadges_116x116_4-ae094c8cf6e545e02e36df7d3e4ca975.png";